import { useContext, useEffect, useState } from "react";
import { Box, Heading } from "@chakra-ui/react";
import { GlobalContext } from "../../context/Provider";
import LayoutView from "../../components/layout";
import Auth from "../../hoc/Auth";

import { Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import Patients from "./section/patients";
import Workers from "./section/workers";
import Overview from "./section/overview";
import Attendances from "./section/attendances";
import RequestForms from "./section/requestForms";
import AuditLogs from "./section/auditLogs";
import { PERMISSIONS } from "../../auth/permissions";
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  const navigate = useNavigate();
  const { authState, can } = useContext(GlobalContext);
  const canManageWorkers = can("workers:manage");
  const isUnitAdmin = authState.user?.role === "unit_admin";
  const unitName = authState.user?.unit || "Unit";
  const shortUnitName = unitName.replace(/\s+unit$/i, "");
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (authState.isAuthenticated && !canManageWorkers) {
      navigate("/dashboard");
    }
  }, [authState, canManageWorkers, navigate]);

  const tabs = [
    {
      tablist: "Overview",
      component: <Overview />,
    },
    {
      tablist: "Workers",
      component: <Workers />,
    },
    {
      tablist: "Patients",
      component: <Patients />,
    },
    {
      tablist: "Attendances",
      component: <Attendances />,
    },
    {
      tablist: "Request Forms",
      component: <RequestForms />,
    },
    ...(can(PERMISSIONS.AUDIT_LOGS_VIEW) ? [{
      tablist: "Audit Logs",
      component: <AuditLogs />,
    }] : []),
  ];

  const handleTabChange = (index) => {
    setTabIndex(index);
  };

  return (
    <LayoutView activePage="Admin">
      <Box mt="5" bg="white" borderRadius="2xl" boxShadow="card" overflow="hidden">
        <Box px={{ base: "4", md: "6" }} py="5" borderBottomWidth="1px">
        <Heading size="md">
          {isUnitAdmin ? `${shortUnitName} Administration` : "Administration"}
        </Heading>
        <Box color="gray.500" fontSize="sm" mt="1">
          {isUnitAdmin
            ? `Manage ${unitName} staff access and review unit-related patients, attendances, request forms and audit activity.`
            : "Manage staff access and review patients, attendances and request forms."}
        </Box>
        </Box>
        <Tabs index={tabIndex} onChange={handleTabChange} isLazy colorScheme="blue">
          <TabList px={{ base: "2", md: "5" }} overflowX="auto" overflowY="hidden">
            {tabs.map((item) => (
              <Tab key={item.tablist} px="5" py="4" whiteSpace="nowrap" fontWeight="700">
                {item.tablist}
              </Tab>
            ))}
          </TabList>
          <TabPanels minH="50vh">
            {tabs.map((item) => (
              <TabPanel key={item.tablist} p={{ base: "3", md: "5" }}>
                {item.component}
              </TabPanel>
            ))}
          </TabPanels>
        </Tabs>
      </Box>
    </LayoutView>
  );
};

export default Auth(Dashboard);
